// extracted by mini-css-extract-plugin
export default {"wrapper-class-name":"AppTextEditor_wrapper-class-name__nBspU","editor-class-name":"AppTextEditor_editor-class-name__qmB-u"};